// No emotion or hooks — rendered via ReactDOMServer.renderToString for Mapbox popups

import { truncateToNearestSpace } from '@app/utils/strings.utils'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'

const formatValue = (v: unknown): string => {
  if (v === null || v === undefined) return ''
  if (typeof v === 'object') return JSON.stringify(v)

  const truncatedValue = truncateToNearestSpace(String(v), 100)

  return truncatedValue
}

export const LivePopup = ({
  props,
  layerName,
  icon = 'rain',
  layerId,
  primaryColour = '#0B2948', // Need to pass in colour properly
}: {
  props: { label: string; value: string | number }[]
  layerName: string
  layerId: string
  primaryColour?: string
  icon?: string
}) => {
  return (
    <div
      className="tooltip-container"
      style={{
        padding: '4px 0',
        backgroundColor: 'white',
        borderRadius: '4px',
        position: 'relative',
        boxShadow: '0px 0px 24px rgba(0,0,0,0.25)',
        overflow: 'hidden',
        minWidth: '200px',
        color: '#0B2948',
      }}
    >
      <span
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '4px',
          height: '100%',
          backgroundColor: primaryColour,
          borderRadius: '4px 0 0 4px',
        }}
      />
      <div style={{ padding: '6px 16px 6px 22px' }}>
        <div
          style={{
            marginBottom: '12px',
            borderBottom: `1px solid #d6d6d6`,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            paddingBottom: '4px',
          }}
        >
          <img
            style={{ height: '24px', width: '24px' }}
            src={`${PUBLIC_ASSETS_BASE_URL}/icons/live_feeds/${layerId}/${icon}.svg`}
          />
          <p
            style={{
              margin: '0 0 6px',
              fontWeight: '500 !important',
              fontSize: '15px',
              fontFamily: 'sans-serif',
              textTransform: 'capitalize',
            }}
          >
            {layerName}
          </p>
        </div>

        <table
          style={{
            borderCollapse: 'collapse',
            fontSize: '13px',
            fontFamily: 'sans-serif',
            width: '100%',
          }}
        >
          <tbody>
            {props.map((property) => (
              <tr key={property.label}>
                <td
                  style={{
                    color: '#0B2948',
                    paddingRight: '12px',
                    paddingBottom: '4px',
                    textTransform: 'capitalize',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'top',
                    fontWeight: 600,
                  }}
                >
                  {property.label.replace(/_/g, ' ')}
                </td>
                <td style={{ fontWeight: 400, paddingBottom: '2px' }}>
                  {formatValue(property.value)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
